import React from 'react'
import Hero from '../../components/CKALandingPage/Hero'
import FeaturedRibbon from '../../components/CKALandingPage/FeaturedRibbon'
import TheDifference from '../../components/CKALandingPage/TheDifference'
import BiblicalPrinciples from '../../components/CKALandingPage/BiblicalPrinciples'
import ChristianClients from '../../components/CKALandingPage/ChristianClients'
import CKABenefits from '../../components/CKALandingPage/CKABenefits'
import CKABenefits2 from '../../components/CKALandingPage/CKABenefits2'
import AdvisorsSection from '../../components/CKALandingPage/AdvisorsSection'
import SignUp from '../../components/CKALandingPage/SignUp'
import DiscoverCKA from '../../components/CKALandingPage/DiscoverCKA'
import MarketingNavigation from '../../navigation/marketing';
import PageFooter from '../../components/ArticleBlocks/PageFooter'

export default function CKALanding() {
    return (
        <MarketingNavigation>
            <div className='w-full h-full '>
                <Hero />
                <FeaturedRibbon />
                <TheDifference />
                <DiscoverCKA />
                <CKABenefits />
                <AdvisorsSection />
                {/* <CKABenefits2 /> */}
                <BiblicalPrinciples />
                <ChristianClients />
                <SignUp />
                <PageFooter />
            </div>
        </MarketingNavigation>
    )
}

CKALanding.isPublic = true;
CKALanding.getLayout = (page) => <>{page}</>;